var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "content-wrapper claim-form-wrapper claim-detail",
      attrs: { tabindex: "0" }
    },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "load-spinner" },
            [
              _c("vue-simple-spinner", {
                attrs: {
                  size: "large",
                  message: "Loading...",
                  "line-fg-color": "#00355f"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("h2", { staticClass: "claim-form-heading" }, [
          _vm._v("Claim Details")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "claim-form" }, [
          _c("div", { staticClass: "claim-form-body" }, [
            _vm.claimType
              ? _c("div", { staticClass: "form-row" }, [
                  _c("span", { staticClass: "form-label" }, [
                    _vm._v("Claim Type:")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "form-value" }, [
                    _vm._v(_vm._s(_vm.claimType))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.submitDate
              ? _c("div", { staticClass: "form-row" }, [
                  _c("span", { staticClass: "form-label" }, [
                    _vm._v("Date Submitted:")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "form-value" }, [
                    _vm._v(_vm._s(_vm.formatDate(_vm.submitDate)))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-row" }, [
              _c("span", { staticClass: "form-label" }, [
                _vm._v("Claim Status:")
              ]),
              _vm._v(" "),
              _vm.isProcessed
                ? _c("span", { staticClass: "form-value processed" }, [
                    _vm._v("Processed")
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isProcessed
                ? _c("span", { staticClass: "form-value unprocessed" }, [
                    _vm._v("Not Processed")
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.dealerLocation
              ? _c("div", { staticClass: "form-row" }, [
                  _c("span", { staticClass: "form-label" }, [
                    _vm._v("Dealer:")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "form-value" }, [
                    _vm.dealerLocation.CompanyName
                      ? _c("span", {
                          domProps: {
                            innerHTML: _vm._s(_vm.dealerLocation.CompanyName)
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _vm.dealerLocation.MailingAddress
                      ? _c("span", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.dealerLocation.MailingAddress)
                          ),
                          _c("br")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dealerLocation.Street2
                      ? _c("span", [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.dealerLocation.Street2)
                          ),
                          _c("br")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.dealerLocation.MailingCity
                      ? _c("span", [
                          _vm._v(_vm._s(_vm.dealerLocation.MailingCity) + ",")
                        ])
                      : _vm._e(),
                    _vm._v(
                      " " +
                        _vm._s(_vm.dealerLocation.MailingState) +
                        " " +
                        _vm._s(_vm.dealerLocation.MailingZip) +
                        "\n                        "
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.invoiceNo
              ? _c("div", { staticClass: "form-row" }, [
                  _c("span", { staticClass: "form-label" }, [
                    _vm._v("Invoice #:")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "form-value" }, [
                    _vm._v(_vm._s(_vm.invoiceNo))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.invoiceDate
              ? _c("div", { staticClass: "form-row" }, [
                  _c("span", { staticClass: "form-label" }, [
                    _vm._v("LMC Invoice Date:")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "form-value" }, [
                    _vm._v(_vm._s(_vm.formatDate(_vm.invoiceDate)))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.claimAmount
              ? _c("div", { staticClass: "form-row" }, [
                  _c("span", { staticClass: "form-label" }, [
                    _vm._v("Amount Requested:")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "form-value" }, [
                    _vm._v("$" + _vm._s(_vm.formatPrice(_vm.claimAmount)))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.currentDueDate
              ? _c("div", { staticClass: "form-row" }, [
                  _c("span", { staticClass: "form-label" }, [
                    _vm._v("Current Due Date:")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "form-value" }, [
                    _vm._v(_vm._s(_vm.formatDate(_vm.currentDueDate)))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.supplierName
              ? _c("div", { staticClass: "form-row" }, [
                  _c("span", { staticClass: "form-label" }, [
                    _vm._v("Supplier:")
                  ]),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "form-value",
                    domProps: { innerHTML: _vm._s(_vm.supplierName) }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.supplierInvoiceNo
              ? _c("div", { staticClass: "form-row" }, [
                  _c("span", { staticClass: "form-label" }, [
                    _vm._v("Supplier Invoice #:")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "form-value" }, [
                    _vm._v(_vm._s(_vm.supplierInvoiceNo))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.supplierInvoiceDate
              ? _c("div", { staticClass: "form-row" }, [
                  _c("span", { staticClass: "form-label" }, [
                    _vm._v("Supplier Invoice Date:")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "form-value" }, [
                    _vm._v(_vm._s(_vm.formatDate(_vm.supplierInvoiceDate)))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.quotedBy
              ? _c("div", { staticClass: "form-row" }, [
                  _c("span", { staticClass: "form-label" }, [
                    _vm._v("Who Quoted Price:")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "form-value" }, [
                    _vm._v(_vm._s(_vm.quotedBy))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.claimReason
              ? _c("div", { staticClass: "form-row" }, [
                  _c("span", { staticClass: "form-label" }, [
                    _vm._v("Reason for Request:")
                  ]),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "form-value",
                    domProps: { innerHTML: _vm._s(_vm.claimReason) }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.claimSubmittedBy
              ? _c("div", { staticClass: "form-row" }, [
                  _c("span", { staticClass: "form-label" }, [
                    _vm._v("Submitted By:")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "form-value" }, [
                    _vm._v(_vm._s(_vm.claimSubmittedBy))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.claimContactName
              ? _c("div", { staticClass: "form-row" }, [
                  _c("span", { staticClass: "form-label" }, [
                    _vm._v("Notification Contact:")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "form-value" }, [
                    _vm._v(_vm._s(_vm.claimContactName))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.claimContactEmail
              ? _c("div", { staticClass: "form-row" }, [
                  _c("span", { staticClass: "form-label" }, [
                    _vm._v("Notification Email:")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "form-value" }, [
                    _vm._v(_vm._s(_vm.claimContactEmail))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "modal-close close-btn",
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                }
              },
              [_vm._v("Close")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "modal-print",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.print()
                  }
                }
              },
              [_vm._v("Print")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4623c664", { render: render, staticRenderFns: staticRenderFns })
  }
}